import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout för hela /rapido-navet. Rendrar bara <Outlet /> — allt innehåll
// ligger i barnrouterna (rapido.index, rapido.prislista, rapido.modeller.$model, m.fl.).
export const Route = createFileRoute("/rapido")({
  component: () => <Outlet />,
});
